import { GOOGLE_OPTIMIZE_EXPERIMENTS, SENTRY_DNS } from "configs";
import { POSTHOG_KEYS } from "configs/posthog";
import { VERY_GOOD_SECURITY } from "configs/very_good_security";
import { DefaultConfigProps } from "models/ThemeConfig";
import { ROUTER_PATHES } from "routes/routes";

const local = {
  stageName: "local",
  basePath: "http://localhost:3333",
  amplify: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_7SUhq2Pyc", // those are defined on https://eu-central-1.console.aws.amazon.com/cloudformation doola-infra services.
      userPoolWebClientId: "49ivv1snar42jpd0lcvj2h40uv",
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.development.aws.doola.com",
        },
      ],
    },
  },
  api: {
    URL: "https://api.development.aws.doola.com",
    GRAPHQL_URL: "https://graphql.development.aws.doola.com/graphql",
  },
  GTM: {
    gtmId: "GTM-T9RKQCS",
  },
  GoogleOptimize: {
    experimentId: GOOGLE_OPTIMIZE_EXPERIMENTS.local,
  },
  banking: {
    veryGoodSecurity: VERY_GOOD_SECURITY.development,
  },
  intercomAppId: "tmtnoscr",
  stripeKey:
    "pk_test_51HRL70GIhH9I2BWrPoDGl8N5K6VDrefxhkbstXmNC6461xcrJCvAFQU6nbYPoIgvjEFl4MvSQej616FcCJjOYOiA00pULyyZ6d",
  payPalClientId:
    "ATXiA7WXrwEwshscna4Y9ZUQSgxNxU-9IZ23ETNe875TZ_KHKoEyoQ1tmX35YzhmF0wOrnE_C13G7s6C",
  sentryDns: SENTRY_DNS.local,
  posthogKeys: POSTHOG_KEYS.local,
};

const development = {
  stageName: "dev",
  basePath: "https://app.development.aws.doola.com",
  amplify: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_7SUhq2Pyc",
      userPoolWebClientId: "49ivv1snar42jpd0lcvj2h40uv",
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.development.aws.doola.com",
        },
      ],
    },
  },
  api: {
    URL: "https://api.development.aws.doola.com",
    GRAPHQL_URL: "https://graphql.development.aws.doola.com/graphql",
  },
  GTM: {
    gtmId: "GTM-T9RKQCS",
  },
  GoogleOptimize: {
    experimentId: GOOGLE_OPTIMIZE_EXPERIMENTS.development,
  },
  intercomAppId: "tmtnoscr",
  stripeKey:
    "pk_test_51HRL70GIhH9I2BWrPoDGl8N5K6VDrefxhkbstXmNC6461xcrJCvAFQU6nbYPoIgvjEFl4MvSQej616FcCJjOYOiA00pULyyZ6d",
  payPalClientId:
    "ATXiA7WXrwEwshscna4Y9ZUQSgxNxU-9IZ23ETNe875TZ_KHKoEyoQ1tmX35YzhmF0wOrnE_C13G7s6C",
  sentryDns: SENTRY_DNS.development,
  posthogKeys: POSTHOG_KEYS.development,
  banking: {
    veryGoodSecurity: VERY_GOOD_SECURITY.development,
  },
};

const staging = {
  stageName: "staging",
  basePath: "https://app.staging.aws.doola.com",
  amplify: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_00STj9XsU",
      userPoolWebClientId: "4kjbt2b5rnc0eov14ergfpbcv1",
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.staging.aws.doola.com",
        },
      ],
    },
  },
  api: {
    URL: "https://api.staging.aws.doola.com",
    GRAPHQL_URL: "https://graphql.staging.aws.doola.com/graphql",
  },
  GTM: {
    gtmId: "GTM-T9RKQCS",
  },
  GoogleOptimize: {
    experimentId: GOOGLE_OPTIMIZE_EXPERIMENTS.staging,
  },
  intercomAppId: "tmtnoscr",
  stripeKey:
    "pk_test_51HRL70GIhH9I2BWrPoDGl8N5K6VDrefxhkbstXmNC6461xcrJCvAFQU6nbYPoIgvjEFl4MvSQej616FcCJjOYOiA00pULyyZ6d",
  payPalClientId:
    "ATXiA7WXrwEwshscna4Y9ZUQSgxNxU-9IZ23ETNe875TZ_KHKoEyoQ1tmX35YzhmF0wOrnE_C13G7s6C",
  sentryDns: SENTRY_DNS.staging,
  posthogKeys: POSTHOG_KEYS.staging,
  banking: {
    veryGoodSecurity: VERY_GOOD_SECURITY.development,
  },
};

const sandbox = {
  stageName: "sandbox",
  basePath: "https://app.sandbox.aws.doola.com",
  amplify: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_jLwbwDzfu",
      userPoolWebClientId: "5vfa21v77u5jcg5gfvtgl17dle",
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.sandbox.aws.doola.com",
        },
      ],
    },
  },
  api: {
    URL: "https://api.sandbox.aws.doola.com",
    GRAPHQL_URL: "https://graphql.sandbox.aws.doola.com/graphql",
  },
  GTM: {
    gtmId: "GTM-T9RKQCS",
  },
  GoogleOptimize: {
    experimentId: GOOGLE_OPTIMIZE_EXPERIMENTS.staging,
  },
  intercomAppId: "pu5xix6z",
  stripeKey:
    "pk_test_51HRL70GIhH9I2BWrPoDGl8N5K6VDrefxhkbstXmNC6461xcrJCvAFQU6nbYPoIgvjEFl4MvSQej616FcCJjOYOiA00pULyyZ6d",
  payPalClientId:
    "ATXiA7WXrwEwshscna4Y9ZUQSgxNxU-9IZ23ETNe875TZ_KHKoEyoQ1tmX35YzhmF0wOrnE_C13G7s6C",
  sentryDns: SENTRY_DNS.sandbox,
  posthogKeys: POSTHOG_KEYS.sandbox,
  banking: {
    veryGoodSecurity: VERY_GOOD_SECURITY.development,
  },
};

const production = {
  stageName: "prod",
  basePath: "https://app.doola.com",
  amplify: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_lAOvyXvkr",
      userPoolWebClientId: "i516bh98nfp2rh0b18f5a1kbg",
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.production.aws.doola.com",
        },
      ],
    },
  },
  api: {
    URL: "https://api.production.aws.doola.com",
    GRAPHQL_URL: "https://graphql.production.aws.doola.com/graphql",
  },
  GTM: {
    gtmId: "GTM-TC26L6Q",
  },
  GoogleOptimize: {
    experimentId: GOOGLE_OPTIMIZE_EXPERIMENTS.production,
  },
  intercomAppId: "pu5xix6z",
  payPalClientId:
    "ASoRSLI1BV-_zEvf-CqXa-jI4tTILqABHlBkV3K-cloKjQXNzaxMqpsbmwwpzLfVbKzzRLb8ClLWsuKv",
  stripeKey:
    "pk_live_51HRL70GIhH9I2BWrxFa2p6VKDDiNsDnHYAysU6hmoHGe5HWV75B16HLaWZdcPrq9vOZqxiSRdPG2EZiXH4HYLGcu00rdjJXKf1",
  sentryDns: SENTRY_DNS.production,
  posthogKeys: POSTHOG_KEYS.production,
  banking: {
    veryGoodSecurity: VERY_GOOD_SECURITY.production,
  },
};

const getConfig = (env: string) => {
  switch (env) {
    case "prod":
    case "production":
      return production;
    case "sandbox":
      return sandbox;
    case "staging":
      return staging;
    case "local":
      return local;
    default:
      return development;
  }
};

export const isProduction = process.env.REACT_APP_ENV === "prod";
export const sidebarWidth = 260;
export const themeConfig: DefaultConfigProps = {
  defaultPath: ROUTER_PATHES.DASHBOARD,
  fontFamily: "'IBM Plex Sans', Arial, sans-serif",
  i18n: "en",
  miniDrawer: false,
  container: true,
  mode: "light",
  presetColor: "default",
  themeDirection: "ltr",
};

const config = {
  ...(process.env.REACT_APP_ENV
    ? getConfig(process.env.REACT_APP_ENV)
    : development),
};

export default config;
